import logo from "./logo.svg";
import "./App.css";
import "./Main.css";
import React, { useState, useRef, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Product from "./pages/product/index";
import OrderPage from "./pages/product/OrderPage/OrderPage";
import LandingPage from "./pages/landingpage/LandingPage.tsx";
import AddMenu from "./pages/product/components/AddMenu/AddMenu.tsx";
import RestaurantSetup from "./pages/restaurantsetup/RestaurantSetup.tsx";
import SettingsForAdmin from "./pages/SettingsForAdmin/SettingsForAdmin.tsx";
import AdminDashboard from "./pages/SettingsForAdmin/AdminDashboard/AdminDashboard.tsx";
import NewRestaurantRequest from "./pages/SettingsForAdmin/NewRestaurantRequest/NewRestaurantRequest.tsx";
import KYCForm from "./pages/restaurantsetup/components/KYCForm/KYCForm.tsx";
import EmployeeRegistrationForm from "./pages/restaurantsetup/components/EmployeeRegistrationForm/EmployeeRegistrationForm.tsx";
import KYCFormRequest from "./pages/SettingsForAdmin/KYCFormRequest/KYCFormRequest.tsx";
import Login from "./pages/Login/Login";
import LoginkycSubmitter from "./pages/KycSubmitter/Login/Login.tsx";
import Register from "./pages/KycSubmitter/Register.tsx";
import SuccessFullyRegistered from "./pages/KycSubmitter/SuccessFullyRegistered/SuccessFullyRegistered";
import Auth from "./hooks/Auth";
import SweetAlertModal from "./pages/components/SweetAlertModal/SweetAlertModal";
import NewUserLogin from "./pages/components/NewUserLogin/NewUserLogin.tsx";
import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
  HubConnectionState,
} from "@microsoft/signalr";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getAPI } from "./hooks/Common";
import { useDispatch, useSelector } from "react-redux";
import { totalNotificationAction } from "./reduxadmin/Actions/NotificationAction.tsx";
import GetCountUnreadNotification from "./hooks/GetCountUnreadNotification";
import jwtDecode from "jwt-decode";
import LoginForCourier from "./pages/Login/LoginForCourier/LoginForCourier";
import RegistrationForCourier from "./pages/Login/LoginForCourier/RegistrationForCourier";
import CourierRegistration from "./pages/Courier/CourierRegistration/CourierRegistration.tsx";
import CourierDashboard from "./pages/Courier/CourierDashboard/CourierDashboard.tsx";
import CourierRequest from "./pages/SettingsForAdmin/CourierRequest/CourierRequest.tsx";
import LoginSelectionDialog from "./pages/Login/LoginSelectionDialog/LoginSelectionDialog.tsx";
import Orders from "./pages/ordersDashbord/Orders.tsx";
import Delivery from "./pages/ordersDashbord/Delivery.tsx";
import PendingOrders from "./pages/Courier/CourierOrders/CourierOrders.tsx";
import CourierOrders from "./pages/Courier/CourierOrders/CourierOrders.tsx";
import OrdersQueue from "./pages/ordersDashbord/OrdersQueue/OrdersQueue.tsx";
import "bootstrap/dist/css/bootstrap.min.css";
import Scheduler from "./pages/Scheduler.js";
import QrCode from "./pages/QrCode/QrCode.tsx";
import OrderDeliveryDetails from "./pages/ordersDashbord/OrderDeliveryDetails/OrderDeliveryDetails.tsx";
import OrderHistoryLog from "./pages/OrderHistoryLog/OrderHistoryLog.tsx";
import ManageRestaurant from "./pages/SettingsForAdmin/AdminManageRestaurant/ManageRestaurant.tsx";
import AddRestaurantCredit from "./pages/RestaurantCredits/AddRestaueantCredit.tsx";
import WithdrawRequest from "./pages/WithdrawRequest/WithdrawRequest.tsx";
import store from "./store.js";
import { triggerReload } from "./reduxadmin/Actions/index.js";
import { connectSignalR } from "./hooks/SignalR/connectSignalR.js";

function App() {
  const [conn, setConn] = useState([]);
  const [notificaiton, setNotification] = useState([]);
  const MySwal = new withReactContent(Swal);
  const [flag, setFlag] = useState(false);
  const totalNotification = useSelector(
    (state) => state.totalNotification.totalNotification
  );
  const [expanded, setExpanded] = useState(false);
  const dispatch = useDispatch();

  const showToastMessage = (msg) => {
    toast.success(msg, {
      position: toast.POSITION.BOTTOM_RIGHT,
      toastId: "success1",
    });
  };

  const countNotification = async () => {
    const countData = await GetCountUnreadNotification();
    dispatch(totalNotificationAction(countData));
  };

  // In other tabs
  window.addEventListener("storage", (event) => {
    if (event.key === "myKey") {
      // Reload the tab
      window.location.reload();
    }
  });

  // Listen for BroadcastChannel messages
  const broadcastChannel = new BroadcastChannel("storage_change_channel");
  broadcastChannel.addEventListener("message", (event) => {
    if (event.data === "storage_changed") {
      // Reload the tab
      console.log(totalNotification);
      var decoded = {};
      const token = localStorage.getItem("gotasteadmintoken");

      if (token != null) {
        try {
          decoded = jwtDecode(token);
          console.log(decoded);
        } catch (error) {
          console.log(error);
        }
      }

      if (decoded.UserRole == "KycSubmitter") {
        window.location.href = "/kyc-form?id=" + decoded.kycId;
      } else if (decoded.loginselection == "yes") {
        setLoginSelection(true);
      } else if (decoded.UserRole == "Admin") {
        window.location.href = "/admin-dashboard";
      } else if (decoded.courierId == "CourierNotFound") {
        window.location.href = "/courier-registration";
      } else if (
        decoded.UserRole == "" &&
        decoded.UserRole == "" &&
        decoded.kycId == "" &&
        decoded.courierId != "CourierNotFound" &&
        decoded.courierId != ""
      ) {
        window.location.href = "/courier-dashboard";
      } else {
        window.location.href = "/";
        // window.location.href = "/";
      }
    } else if (event.data === "restaurantChanged") {
      window.location.href = window.location.href;
    }
  });

  // const connectSignalR = async () => {
  //   try {
  //     console.log("connectSignalR");
  //     const connection = new HubConnectionBuilder()
  //       .withUrl(process.env.REACT_APP_SECRET + "/SignalR-hub") // <- Provide the connection URL here
  //       .configureLogging(LogLevel.Information)
  //       .build();

  //     connection.on("GetNotificationForSuperAdmin", (message) => {
  //       if (message != null) {
  //         if (!flag) {
  //           showToastMessage(message.notificationMessage);
  //           setNotification(message.notificationMessage);
  //           countNotification();
  //           setFlag(true);
  //         }
  //       }
  //     });
  //     connection.on("NewChat", (message) => {
  //       console.log(message);
  //     });

  //     const restauranrData = localStorage.getItem("parentrestaurant");
  //     const restaurantObj = JSON.parse(restauranrData);
  //     console.log("restauranrData", JSON.parse(restauranrData));

  //     connection.on("UpdateQueue", (message) => {
  //       console.log(message);
  //       console.log("UpdateQueueFor called" + restaurantObj.id);
  //       localStorage.setItem("loadQueue", "Load");

  //       // Broadcast the change to other tabs
  //       const broadcastChannel = new BroadcastChannel("loadQueue");
  //       broadcastChannel.postMessage("loadQueueDatas");
  //       broadcastChannel.close();
  //     });
  //     connection.on("GetNotification", (message) => {
  //       console.log(message);
  //       console.log("GetNotification called");
  //     });
  //     await connection.start();
  //     await connection.invoke("NewConnectionToGroup", "SuperAdmin");
  //     await connection.invoke(
  //       "NewConnectionToGroupWithMethodName",
  //       "2e528a48-2121-48bd-97d4-b6ec8865bff2",
  //       "NewChat"
  //     );
  //     await connection.invoke(
  //       "NewConnectionToGroupWithMethodName",
  //       "2e528a48-2121-48bd-97d4-b6ec8865bff2",
  //       "GetNotification"
  //     );
  //     await connection.invoke(
  //       "NewConnectionToGroupWithMethodName",
  //       restaurantObj.id,
  //       "UpdateQueue"
  //     );
  //     setConn(connection);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const connectSignalR = async () => {
  //   try {
  //     console.log("Connecting to SignalR...");
  //     const connection = new HubConnectionBuilder()
  //       .withUrl(process.env.REACT_APP_SECRET + "/SignalR-hub") // Ensure this URL is correct
  //       .configureLogging(LogLevel.Information)
  //       .withAutomaticReconnect() // Automatically attempt to reconnect
  //       .build();

  //     // Set up listeners only once
  //     connection.on("GetNotificationForSuperAdmin", (message) => {
  //       if (message) {
  //         if (!flag) {
  //           showToastMessage(message.notificationMessage);
  //           setNotification(message.notificationMessage);
  //           countNotification();
  //           setFlag(true);
  //         }
  //       }
  //     });

  //     connection.on("NewChat", (message) => {
  //       console.log(message);
  //     });

  //     const restauranrData = localStorage.getItem("restaurant");
  //     const restaurantObj = JSON.parse(restauranrData);
  //     console.log("restauranrData", restaurantObj);

  //     connection.on("UpdateQueue", (message) => {
  //       console.log(message);
  //       // alert("called");
  //       console.log("UpdateQueueFor called" + restaurantObj.id);
  //       localStorage.setItem("loadQueue", "Load");

  //       // Broadcast the change to other tabs
  //       const broadcastChannel = new BroadcastChannel("loadQueue");
  //       broadcastChannel.postMessage("loadQueueDatas");
  //       broadcastChannel.close();
  //     });

  //     connection.on("GetNotification", (message) => {
  //       console.log(message);
  //       console.log("GetNotification called");
  //     });

  //     // Start the connection
  //     await connection.start();
  //     console.log("SignalR connected.");

  //     // Call server methods after connection starts
  //     await connection.invoke("NewConnectionToGroup", "SuperAdmin");
  //     await connection.invoke(
  //       "NewConnectionToGroupWithMethodName",
  //       "2e528a48-2121-48bd-97d4-b6ec8865bff2",
  //       "NewChat"
  //     );
  //     await connection.invoke(
  //       "NewConnectionToGroupWithMethodName",
  //       "2e528a48-2121-48bd-97d4-b6ec8865bff2",
  //       "GetNotification"
  //     );
  //     await connection.invoke(
  //       "NewConnectionToGroupWithMethodName",
  //       restaurantObj.id,
  //       "UpdateQueue"
  //     );

  //     // Save the connection instance to state
  //     setConn(connection);

  //     // Handle connection close
  //     connection.onclose(async () => {
  //       console.log("Disconnected. Attempting to reconnect...");
  //       try {
  //         await connection.start(); // Attempt to restart the connection
  //         console.log("Reconnected.");
  //       } catch (err) {
  //         console.error("Reconnection failed:", err);
  //       }
  //     });
  //   } catch (error) {
  //     console.error("SignalR connection error:", error);
  //   }
  // };
  const [connectionStatus, setConnectionStatus] = useState("Disconnected");
  // const connectSignalR = async (
  //   setConn,
  //   showToastMessage,
  //   countNotification,
  //   setNotification,
  //   flag,
  //   setFlag
  // ) => {
  //   try {
  //     console.log("Connecting to SignalR...");

  //     const connection = new HubConnectionBuilder()
  //       .withUrl(`${process.env.REACT_APP_SECRET}/SignalR-hub`)
  //       .configureLogging(LogLevel.Information)
  //       .withAutomaticReconnect({
  //         nextRetryDelayInMilliseconds: (retryContext) => {
  //           // exponential backoff up to 10s
  //           return Math.min(
  //             1000 * (retryContext.previousRetryCount + 1),
  //             10000
  //           );
  //         },
  //       })
  //       .build();

  //     // ---------------- Event Handlers ----------------
  //     connection.on("GetNotificationForSuperAdmin", (message) => {
  //       if (message && !flag) {
  //         showToastMessage(message.notificationMessage);
  //         setNotification(message.notificationMessage);
  //         countNotification();
  //         setFlag(true);
  //       }
  //     });

  //     connection.on("NewChat", (message) => {
  //       console.log("NewChat:", message);
  //     });

  //     connection.on("UpdateQueue", (message) => {
  //       console.log("UpdateQueue:", message);
  //       localStorage.setItem("loadQueue", "Load");
  //       store.dispatch(triggerReload());
  //     });

  //     connection.on("GetNotification", (message) => {
  //       console.log("GetNotification:", message);
  //     });

  //     // ---------------- Connection Start ----------------
  //     const startConnection = async () => {
  //       if (connection.state === HubConnectionState.Disconnected) {
  //         try {
  //           await connection.start();
  //           console.log("SignalR connected.");
  //           setConnectionStatus("Connected");
  //           await connection.invoke("NewConnectionToGroup", "SuperAdmin");
  //           await joinRestaurantGroup();
  //         } catch (err) {
  //           console.error("SignalR connection start failed:", err);
  //           setConnectionStatus("SignalR connection start failed:");
  //         }
  //       }
  //     };

  //     const joinRestaurantGroup = async () => {
  //       const restaurantData = localStorage.getItem("restaurant");
  //       if (restaurantData) {
  //         const restaurantObj = JSON.parse(restaurantData);
  //         const restaurantId = restaurantObj?.id;
  //         if (restaurantId) {
  //           try {
  //             console.log("Joining restaurant group:", restaurantId);
  //             await connection.invoke(
  //               "NewConnectionToGroupWithMethodName",
  //               restaurantId,
  //               "UpdateQueue"
  //             );
  //           } catch (err) {
  //             console.warn("Group join failed:", err);
  //           }
  //         }
  //       }
  //     };

  //     await startConnection();

  //     // Wait for restaurant data if loaded later
  //     const restaurantCheckInterval = setInterval(() => {
  //       if (localStorage.getItem("restaurant")) {
  //         joinRestaurantGroup();
  //         clearInterval(restaurantCheckInterval);
  //       }
  //     }, 2000);

  //     setConn(connection);

  //     // ---------------- Handle Reconnection ----------------
  //     connection.onreconnecting(() => {
  //       console.warn("SignalR reconnecting...");
  //     });

  //     connection.onreconnected(async () => {
  //       console.log("SignalR reconnected successfully.");
  //       toast.error("Reconnected to server.", {
  //         position: toast.POSITION.BOTTOM_RIGHT,
  //         toastId: "reconnected",
  //       });
  //       await connection.invoke("NewConnectionToGroup", "SuperAdmin");
  //       await joinRestaurantGroup();
  //     });

  //     connection.onclose(async () => {
  //       console.warn("SignalR closed. Attempting to reconnect...");
  //       await startConnection();
  //     });

  //     // ---------------- Handle Sleep/Wake ----------------
  //     document.addEventListener("visibilitychange", async () => {
  //       if (document.visibilityState === "visible") {
  //         console.log(
  //           "App woke up or tab is visible. Checking SignalR state..."
  //         );
  //         toast.error("Reconnected to server.", {
  //           position: toast.POSITION.BOTTOM_RIGHT,
  //           toastId: "reconnected",
  //         });
  //         await startConnection();
  //       }
  //     });

  //     // ---------------- Handle Network Loss/Recovery ----------------
  //     window.addEventListener("online", async () => {
  //       console.log("Network online. Checking SignalR connection...");
  //       await startConnection();
  //     });

  //     window.addEventListener("offline", () => {
  //       console.warn("Network offline. SignalR will reconnect when online.");
  //     });

  //     // ---------------- Optional Periodic Health Check ----------------
  //     setInterval(async () => {
  //       console.log("Performing SignalR health check...");
  //       console.log("Connection state:", connection.state);

  //       if (
  //         connection.state === HubConnectionState.Disconnected &&
  //         navigator.onLine
  //       ) {
  //         console.log("Health check: Reconnecting SignalR...");
  //         await startConnection();
  //       }
  //     }, 30000); // every 30s
  //   } catch (error) {
  //     console.error("SignalR connection error:", error);
  //   }
  // };

  const [gotasteToken, setGotasteToken] = useState(
    localStorage.getItem("gotasteadmintoken")
  );
  const [parentRestaurant, setParentRestaurant] = useState(
    localStorage.getItem("parentrestaurant")
  );

  useEffect(() => {
    const cleanup = connectSignalR(
      setConn,
      (msg) => toast.info(msg),
      () => console.log("countNotification"),
      setNotification,
      flag,
      setFlag,
      setConnectionStatus
    );

    return () => {
      if (cleanup instanceof Function) cleanup();
    };
  }, [gotasteToken, parentRestaurant]);

  useEffect(() => {
    function handleStorageChange() {
      setGotasteToken(localStorage.getItem("gotasteadmintoken"));
      setParentRestaurant(localStorage.getItem("parentrestaurant"));
    }

    // Add a listener to detect storage changes
    window.addEventListener("storage", handleStorageChange);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (
      localStorage.getItem("gotasteadmintoken") &&
      localStorage.getItem("parentrestaurant")
    ) {
      connectSignalR();
    }
  }, [flag, totalNotification]);

  const [loginSelection, setLoginSelection] = useState(false);

  const handleSelectionChange = () => {
    setLoginSelection(!false);
  };

  return (
    <>
      <div
        onClick={() => setExpanded((prev) => !prev)}
        style={{
          position: "fixed",
          bottom: "10px",
          right: "10px",
          zIndex: 1050,
          background: "transparent",
          borderRadius: "20px",
          padding: "10px 16px",
          fontFamily: "'Segoe UI', sans-serif",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          transition: "all 0.3s ease-in-out",
        }}
        title={connectionStatus} // Tooltip on hover
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: expanded ? "8px" : "0px",
            background: "#fff",
            // border: "1px solid #dee2e6",
            borderRadius: "20px",
            padding: expanded ? "6px 12px" : "6px",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
            transition: "all 0.3s ease-in-out",
          }}
        >
          <span
            style={{
              display: "inline-block",
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor:
                connectionStatus === "Connected"
                  ? "#28a745"
                  : connectionStatus === "Connecting..."
                  ? "#ffc107"
                  : connectionStatus === "Connection failed"
                  ? "#dc3545"
                  : connectionStatus === "Reconnecting..."
                  ? "#17a2b8"
                  : connectionStatus === "Disconnected"
                  ? "#6c757d"
                  : connectionStatus === "Online"
                  ? "#28a745"
                  : connectionStatus === "Offline"
                  ? "#dc3545"
                  : "#000",
              transition: "background-color 0.3s ease-in-out",
              animation:
                connectionStatus === "Reconnecting..."
                  ? "blink 1s infinite"
                  : "none",
            }}
          ></span>

          {expanded && (
            <span
              style={{
                fontWeight: 600,
                fontSize: "13px",
                color: "#333",
                transition: "opacity 0.3s ease-in-out",
              }}
            >
              {connectionStatus}
            </span>
          )}
        </div>

        <style>
          {`
        @keyframes blink {
          0% { opacity: 1; }
          50% { opacity: 0.3; }
          100% { opacity: 1; }
        }
      `}
        </style>
      </div>

      <BrowserRouter>
        <Routes>
          <Route
            path="/manage-product"
            element={
              <Auth
                role={["Admin", "SuperAdmin", "Owner", "GM", "LocalManager"]}
                child={<Product />}
              />
            }
          />
          <Route
            path="/orderpage"
            element={
              <Auth
                role={["Admin", "SuperAdmin", "Owner", "GM", "LocalManager"]}
                child={<OrderPage />}
              />
            }
          />
          <Route
            path="/"
            element={
              <Auth
                role={["Admin", "SuperAdmin", "Owner", "GM", "LocalManager"]}
                child={<LandingPage />}
              />
            }
          />
          <Route
            path="/addmenu"
            element={
              <Auth
                role={["Admin", "SuperAdmin", "Owner", "GM", "LocalManager"]}
                child={<AddMenu />}
              />
            }
          />
          <Route
            path="/restaurant-setup"
            element={
              <Auth
                role={["Admin", "SuperAdmin", "Owner", "GM", "LocalManager"]}
                child={<RestaurantSetup />}
              />
            }
          />
          <Route
            path="/admin-settings"
            element={
              <Auth
                role={["Admin", "SuperAdmin", "Owner", "GM", "LocalManager"]}
                child={<SettingsForAdmin />}
              />
            }
          />
          <Route
            path="/admin-dashboard"
            element={<Auth role={["Admin"]} child={<AdminDashboard />} />}
          />
          <Route
            path="/manage-restaurant-admin"
            element={<Auth role={["Admin"]} child={<ManageRestaurant />} />}
          />
          <Route
            path="/restaurant-request"
            element={
              <Auth
                role={["Admin", "SuperAdmin", "Owner", "GM", "LocalManager"]}
                child={<NewRestaurantRequest />}
              />
            }
          />

          <Route
            path="/pending-orders"
            element={<CourierOrders></CourierOrders>}
          />

          <Route
            path="/kyc-form"
            element={<Auth role={["KycSubmitter"]} child={<KYCForm />} />}
          />
          <Route
            path="/employee-registration"
            element={<EmployeeRegistrationForm />}
          />
          <Route
            path="/kyc-requests"
            element={<Auth role={["Admin"]} child={<KYCFormRequest />} />}
          />
          <Route
            path="/courier-requests"
            element={<Auth role={["Admin"]} child={<CourierRequest />} />}
          />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/loginkyc" element={<LoginkycSubmitter />} />
          <Route
            path="/successfullyregistered"
            element={<SuccessFullyRegistered />}
          />
          <Route path="/modal" element={<SweetAlertModal />} />
          <Route path="/kyc-form-without-auth" element={<KYCForm />} />
          <Route path="/kyc-requests" element={<KYCFormRequest />} />
          <Route
            path="/employeeregistration"
            element={<EmployeeRegistrationForm />}
          />
          <Route path="/newlogin" element={<NewUserLogin />} />
          <Route path="/loginforcourier" element={<LoginForCourier />} />
          <Route
            path="/registrationforcourier"
            element={<RegistrationForCourier />}
          />
          <Route
            path="/courier-registration"
            element={<CourierRegistration />}
          />
          <Route path="/courier-dashboard" element={<CourierDashboard />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders-queue" element={<OrdersQueue />} />
          <Route path="/delivery" element={<Delivery />} />

          <Route path="/time" element={<Scheduler />} />
          <Route path="/scan-qr-code" element={<QrCode />} />
          <Route
            path="/order-details/:orderId"
            element={
              <Auth
                role={["Admin", "SuperAdmin", "Owner", "GM", "LocalManager"]}
                child={<OrderDeliveryDetails />}
              />
            }
          />
          <Route path="/order-history-log" element={<OrderHistoryLog />} />
          <Route
            path="/manage-credits"
            element={<Auth role={["Admin"]} child={<AddRestaurantCredit />} />}
          />
          <Route path="/withdraw-request" element={<WithdrawRequest />} />
        </Routes>
        <ToastContainer />
      </BrowserRouter>
      {/* {loginSelection ? (
        <LoginSelectionDialog
          open={loginSelection}
          onHandleAddItem={handleSelectionChange}
        />
      ) : (
        ""
      )} */}
    </>
  );
}

export default App;
